import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import cx from 'classnames';
import SmallHeader from '../components/SmallHeader';
import browserOptimize from '../Util/BrowserOptimize';
import { fetchToken, fetchFiles } from '../Util/PrivateFiles';

if (typeof sessionStorage === 'undefined') {
  global.sessionStorage = {
    getItem: () => {},
    setItem: () => {},
    removeItem: () => {}
  };
}

class Partners extends PureComponent {
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.state = {
      message: null,
      token: sessionStorage.getItem('token'),
      files: [],
      errors: {}
    };
  }

  componentWillMount() {
    if (this.state.token && !this.state.files.length) {
      this.getFiles(this.state.token);
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.token !== nextState.token) {
      if (nextState.token) {
        sessionStorage.setItem('token', nextState.token);
      } else {
        sessionStorage.removeItem('token');
      }
    }
    if (nextState.token && !nextState.files.length) {
      this.getFiles(nextState.token);
    }
  }

  getFiles(token) {
    fetchFiles(token)
      .then(files => {
        this.setState(state => ({
          ...state,
          files
        }));
      })
      .catch(e => {
        this.setState(state => ({
          ...state,
          token: null,
          errors: { files: e },
          message: 'Session expired'
        }));
      });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState(state => ({
      ...state,
      errors: {}
    }));

    fetchToken('swivel', this.password.value)
      .then(data => {
        // CLEAR FORM AND SHOW MESSAGE..
        if (data.token) {
          this.form.reset();
          this.setState(state => ({
            ...state,
            token: data.token,
            message: ''
          }));
        }
      })
      .catch(e => {
        this.setState(state => ({
          ...state,
          errors: { password: e },
          message: 'Incorrect password'
        }));
      });
  }

  render() {
    const { token, message, files, errors } = this.state;

    const fileEls = files.map(file => (
      <li key={file.name}>
        <a href={file.url}>{file.name}</a>
      </li>
    ));
    return (
      <div className="form partners">
        <Helmet>
          <title>Partners - Swivel VR</title>
        </Helmet>
        <SmallHeader title="Partners" />
        <div className="container">
          {!token && (
            <form
              method="POST"
              action="/"
              className="form__body"
              ref={f => {
                this.form = f;
              }}
              onSubmit={this.handleLogin}
            >
              <h1>Enter your code to get access to Investment Opportunities</h1>
              <div className={cx('input-wrap', { error: errors.password })}>
                <input
                  id="password"
                  name="password"
                  placeholder="XXXXXXXX"
                  ref={f => {
                    this.password = f;
                  }}
                  type="password"
                  autoComplete="off"
                />
              </div>
              <button type="submit">Submit Code</button>
              <div className="fc-purple m-t-20 t-center">{message}</div>
            </form>
          )}
          {token && (
            <div className="container">
              <div className="whatever">
                <p>Investment Opportunities:</p>
                <ul>{fileEls}</ul>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Partners;



// WEBPACK FOOTER //
// ./src/pages/partners.js